import { useState } from "react";
import { ChevronDown, Pencil, Trash2, Swords } from "lucide-react";

export default function BookNpcCard({ npc, onEdit, onDelete }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div data-testid={`book-npc-card-${npc.id}`} className="rounded-lg border border-[#8b5a2b]/40 bg-[#f1e2c2]/70 overflow-hidden">
      <button
        data-testid={`book-npc-toggle-${npc.id}`}
        onClick={() => setExpanded((e) => !e)}
        className="w-full flex items-center gap-3 p-2.5 text-left hover:bg-[#8b5a2b]/10 transition-colors duration-150"
      >
        {npc.image_url ? (
          <img src={npc.image_url} alt="" className="w-10 h-10 rounded-full object-cover border-2 border-[#8b5a2b]/50" />
        ) : (
          <div className="w-10 h-10 rounded-full bg-[#8b5a2b]/20 flex items-center justify-center border-2 border-[#8b5a2b]/50">
            <Swords className="w-4 h-4 text-[#5c3a1a]" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="font-display text-sm text-[#3b2a1a] truncate">{npc.name || "Unnamed"}</p>
          {npc.role && <p className="text-[10px] text-[#5c3a1a]/70 truncate">{npc.role}</p>}
        </div>
        <ChevronDown className={`w-4 h-4 text-[#5c3a1a]/60 shrink-0 transition-transform duration-200 ${expanded ? "rotate-180" : ""}`} />
      </button>
      {expanded && (
        <div className="px-3 pb-3 space-y-2 text-[#3b2a1a]">
          <div className="flex gap-3 text-xs font-mono-sheet">
            <span>AC <b>{npc.ac}</b></span>
            <span>HP <b>{npc.hp_max}</b></span>
            <span>Perc <b>{npc.perception >= 0 ? `+${npc.perception}` : npc.perception}</b></span>
          </div>
          {npc.attacks?.length > 0 && (
            <div className="space-y-0.5">
              {npc.attacks.map((a, i) => (
                <p key={i} className="text-xs">
                  <b>{a.name || "Attack"}</b> {a.bonus >= 0 ? `+${a.bonus}` : a.bonus}, {a.damage}
                </p>
              ))}
            </div>
          )}
          {npc.abilities && <p className="text-xs whitespace-pre-wrap italic">{npc.abilities}</p>}
          <div className="flex gap-2 pt-1">
            <button data-testid={`book-npc-edit-${npc.id}`} onClick={() => onEdit(npc)} className="flex items-center gap-1 text-[10px] uppercase text-[#5c3a1a] hover:text-[#8b1a1a]">
              <Pencil className="w-3 h-3" /> Edit
            </button>
            <button data-testid={`book-npc-delete-${npc.id}`} onClick={() => onDelete(npc.id)} className="flex items-center gap-1 text-[10px] uppercase text-[#5c3a1a] hover:text-[#8b1a1a]">
              <Trash2 className="w-3 h-3" /> Remove
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
